import React, { useState, useEffect } from "react";
import "./index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const AddNewUser = ({ isOpen, onClose, fetchUserData, editUser = null, isEditMode = false }) => {
  const [formValues, setFormValues] = useState({
    user_id: "",
    name: "",
    gender: "",
    email: "",
    mobile: "",
    organization: "Upl Snipe",
    Date_of_birth: "",
    address: "",
    state_name: "",
    city_name: "",
    department: "Admin",
    role: "",
    activation: false,
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user_id, setUser_id] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [Date_of_birth, setDate_Of_Birth] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [selectedRole, setRoleName] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [activation, setActivation] = useState(false);
  
  const [sequenceValue, setSequenceValue] = useState("Auto-generated");
  
  const { COLORS } = useThemeMode();
  const aiDishaApi = createInstance("DISHA");

  const roleNames = {
    Admin: "Admin"
  };

  useEffect(() => {
    if (!isOpen) return;

    fetchStates(); 

    if (isEditMode && editUser) {
      setUser_id(editUser.user_id || "");
      setName(editUser.name || "");
      setEmail(editUser.email || "");
      setMobile(editUser.mobile || "");
      setDate_Of_Birth(editUser.Date_of_birth || "");
      setGender(editUser.gender || "");
      setAddress(editUser.address || "");
      setRoleName(editUser.role || "");
      setSelectedState(editUser.state_name || "");
      setSelectedCity(editUser.city_name || "");
      setActivation(editUser.activation || false);
      
      setFormValues(prev => ({
        ...prev,
        organization: "Upl Snipe",
        department: "Admin"
      }));

      if (editUser.state_name) {
        fetchAllCities(editUser.state_name);
      }
    } else {
      clearForm();
      setSequenceValue("Auto-generated"); 
    }
  }, [isEditMode, editUser, isOpen]);

  const validateField = (fieldName, value) => {
    let errorMsg = null;
    const safeValue = typeof value === "string" ? value.trim() : value;

    switch (fieldName) {
      case "name":
        if (!safeValue) errorMsg = "Full Name is required.";
        break;
      case "gender":
        if (!safeValue) errorMsg = "Gender is required.";
        break;
      case "email":
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!safeValue) errorMsg = "Email ID is required.";
        else if (!emailPattern.test(safeValue)) errorMsg = "Enter a valid Email ID.";
        break;
      case "mobile":
        if (!safeValue) errorMsg = "Mobile number is required.";
        else if (String(safeValue).length !== 10) errorMsg = "Mobile number must be exactly 10 digits.";
        break;
      case "Date_of_birth":
        if (!safeValue) errorMsg = "Date of Birth is required.";
        break;
      case "address":
        if (!safeValue) errorMsg = "Address is required.";
        break;
      case "state":
        if (!safeValue) errorMsg = "State is required.";
        break;
      case "city":
        if (!safeValue) errorMsg = "City is required.";
        break;
      case "role":
        if (!safeValue) errorMsg = "Role is required.";
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
    return errorMsg;
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    const nameErr = validateField("name", name);
    const genderErr = validateField("gender", gender);
    const emailErr = validateField("email", email);
    const mobileErr = validateField("mobile", mobile);
    const dobErr = validateField("Date_of_birth", Date_of_birth);
    const addressErr = validateField("address", address);
    const stateErr = validateField("state", selectedState);
    const cityErr = validateField("city", selectedCity);
    const roleErr = validateField("role", selectedRole);

    if (nameErr || genderErr || emailErr || mobileErr || dobErr || addressErr || stateErr || cityErr || roleErr) {
      return;
    }

    try {
      setIsSubmitting(true);
      let response;
      
      if (isEditMode) {
        response = await aiDishaApi.put(
          `/update-subsequent-admin`,
          {
            name: name.trim(),
            email: email.trim(),
            mobile: parseInt(mobile, 10), 
            Date_of_birth: Date_of_birth,
            address: address.trim(),
            activation: activation,
            organization: formValues.organization,
          },
          {
            params: {
              user_id: user_id,
              gender: gender,
              state_name: selectedState,
              city_name: selectedCity,
              role: selectedRole,
            },
          }
        );
      } else {
        response = await aiDishaApi.post(
          "/create-subsequent-admin",
          {
            name: name.trim(),
            email: email.trim(),
            mobile: mobile,
            Date_of_birth: Date_of_birth,
            address: address.trim(),
          },
          {
            params: {
              gender: gender,
              state_name: selectedState,
              city_name: selectedCity,
              status: "InActive",
              role: selectedRole,
            },
          }
        );
      }

      if (response.status === 200) {
        toast.success(`User ${isEditMode ? 'updated' : 'added'} successfully`, { autoClose: 3000 });
        clearForm();
        onClose();
        fetchUserData();
      }
    } catch (error) {
      console.error("Error with user operation:", error);
      
      if (error.response?.data?.detail && Array.isArray(error.response.data.detail)) {
        const backendErrors = {};
        error.response.data.detail.forEach((err) => {
          const fieldName = err.loc[err.loc.length - 1]; 
          
          if (fieldName === "name") backendErrors.name = err.msg;
          else if (fieldName === "email") backendErrors.email = err.msg;
          else if (fieldName === "mobile") backendErrors.mobile = err.msg;
          else if (fieldName === "address") backendErrors.address = err.msg;
          else backendErrors[fieldName] = err.msg;
        });

        if (Object.keys(backendErrors).length > 0) {
          setErrors(backendErrors);
          setIsSubmitting(false);
          return; 
        }
      }

      let errorMessage = isEditMode ? "Error updating user" : "Error adding user";
      if (error.response?.data) {
        if (typeof error.response.data.detail === "string") {
          errorMessage = error.response.data.detail;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
      
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearForm = () => {
    setName("");
    setEmail("");
    setMobile("");
    setDate_Of_Birth("");
    setAddress("");
    setGender("");
    setSelectedState("");
    setSelectedCity("");
    setRoleName("");
    setUser_id("");
    setActivation(false);
    setSequenceValue("Auto-generated");
    setErrors({});
  };

  const handleStateDropdown = (event) => {
    const stateValue = event.target.value;
    setSelectedState(stateValue);
    validateField("state", stateValue);
    fetchAllCities(stateValue);
    setSelectedCity("");
  };

  const handleCityDropdown = (event) => {
    setSelectedCity(event.target.value);
    validateField("city", event.target.value);
  };

  const handleDropdownChange1 = (event) => {
    setRoleName(event.target.value);
    validateField("role", event.target.value);
  };

  const fetchStates = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-states");
      const statesData = response.data;
      if (Array.isArray(statesData)) {
        setStates(statesData);
      } else {
        const statesArray = statesData?.states || statesData?.data || [];
        setStates(Array.isArray(statesArray) ? statesArray : []);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    }
  };

  const fetchAllCities = async (state) => {
    try {
      const response = await aiDishaApi.get(`/filter_cities?state_name=${state}`);
      const citiesData = response.data;
      if (Array.isArray(citiesData)) {
        setCities(citiesData);
      } else {
        const citiesArray = citiesData?.cities || citiesData?.data || [];
        setCities(Array.isArray(citiesArray) ? citiesArray : []);
      }
    } catch (error) {
      console.error("Error fetching all cities in the given state" + error);
      setCities([]);
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050
      }}
    >
      {/* 🚨 MOVED: Style block safely outside of flex containers */}
      <style>
        {`
          .dark-placeholder::placeholder {
            color: #6b7280 !important;
            opacity: 1 !important;
          }
        `}
      </style>

      {/* 🚨 FIXED: margin top explicitly pushes it down away from your dashboard's header */}
      <div className="modal-dialog modal-lg w-50 modal-dialog-scrollable" style={{ marginTop: "60px" }}>
        
        <form 
          className="modal-content" 
          onSubmit={handleFormSubmit}
          style={{ background: COLORS.primary || "#ffffff", color: COLORS.text }}
        >
          {/* 🚨 FIXED: flexShrink: 0 absolutely forces this header to render its full height */}
          <div className="modal-header border-0" style={{ flexShrink: 0 }}>
            <h5 className="modal-title" style={{ color: COLORS.text, fontFamily: "Poppins" }}>
              {isEditMode ? "Edit User" : "Add New User"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
                  User ID
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={isEditMode ? user_id : sequenceValue}
                  readOnly
                  tabIndex={-1}
                  style={{ background: "#f3f4f6", color: "#111827", border: "1px solid #d1d5db", cursor: "not-allowed", fontWeight: "600" }}
                />
              </div>

              <div className="col-sm-8 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.name ? "#d32f2f" : COLORS.text }}>
                  Full Name
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm dark-placeholder"
                  placeholder="Enter Name"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.name ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={name}
                  onBlur={(e) => validateField("name", e.target.value)}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (errors.name) setErrors({ ...errors, name: null });
                  }}
                />
                {errors.name && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.name}</span>}
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.gender ? "#d32f2f" : COLORS.text }}>
                  Gender
                </label>
                <select
                  className="form-select form-select-sm"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.gender ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={gender}
                  onBlur={(e) => validateField("gender", e.target.value)}
                  onChange={(e) => {
                    setGender(e.target.value);
                    if (errors.gender) setErrors({ ...errors, gender: null });
                  }}
                >
                  <option value="" disabled>Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                {errors.gender && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.gender}</span>}
              </div>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.email ? "#d32f2f" : COLORS.text }}>
                  Email ID
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm dark-placeholder"
                  placeholder="Enter Email ID"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.email ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={email}
                  onBlur={(e) => validateField("email", e.target.value)}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (errors.email) setErrors({ ...errors, email: null });
                  }}
                />
                {errors.email && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.email}</span>}
              </div>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.mobile ? "#d32f2f" : COLORS.text }}>
                  Mobile
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm dark-placeholder"
                  placeholder="Enter Mobile Number"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.mobile ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={mobile}
                  onBlur={(e) => validateField("mobile", e.target.value)}
                  onChange={(e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, "");
                    setMobile(digitsOnly);
                    if (errors.mobile) setErrors({ ...errors, mobile: null });
                  }}
                  maxLength={10}
                  inputMode="numeric"
                />
                {errors.mobile && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.mobile}</span>}
              </div>

              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
                  Organization
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formValues.organization}
                  readOnly
                  style={{ background: "#f3f4f6", color: "#6b7280", border: "1px solid #d1d5db", cursor: "not-allowed" }}
                />
              </div>

              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.Date_of_birth ? "#d32f2f" : COLORS.text }}>
                  Date of Birth
                </label>
                <div style={{ border: errors.Date_of_birth ? "1px solid #d32f2f" : "none", borderRadius: "4px" }}>
                  <DatePicker
                    selected={(() => {
                      if (!Date_of_birth) return null;
                      const parsed = new Date(`${Date_of_birth}T00:00:00`);
                      return isNaN(parsed.getTime()) ? null : parsed;
                    })()}
                    onChange={(date) => {
                      if (!date) {
                        setDate_Of_Birth("");
                        validateField("Date_of_birth", "");
                        return;
                      }
                      const yyyy = date.getFullYear();
                      const mm = String(date.getMonth() + 1).padStart(2, "0");
                      const dd = String(date.getDate()).padStart(2, "0");
                      const formattedDate = `${yyyy}-${mm}-${dd}`;
                      setDate_Of_Birth(formattedDate);
                      validateField("Date_of_birth", formattedDate);
                    }}
                    onBlur={() => validateField("Date_of_birth", Date_of_birth)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                    maxDate={new Date()}
                    className="form-control form-control-sm dob-datepicker-input dark-placeholder"
                    wrapperClassName="w-100"
                    style={{ background: "#ffffff", color: "#111827", border: "1px solid #d1d5db" }}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                {errors.Date_of_birth && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.Date_of_birth}</span>}
              </div>

              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.address ? "#d32f2f" : COLORS.text }}>
                  Address
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm dark-placeholder"
                  placeholder="Enter your address"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.address ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={address}
                  onBlur={(e) => validateField("address", e.target.value)}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    if (errors.address) setErrors({ ...errors, address: null });
                  }}
                />
                {errors.address && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.address}</span>}
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.state ? "#d32f2f" : COLORS.text }}>
                  State
                </label>
                <select
                  className="form-select form-select-sm"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.state ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={selectedState}
                  onBlur={(e) => validateField("state", e.target.value)}
                  onChange={handleStateDropdown}
                >
                  <option value="" disabled>Select State</option>
                  {Array.isArray(states) && states.map((state, index) => {
                    const stateValue = typeof state === 'string' ? state : state?.state_name || state?.name || state?.value || '';
                    const stateDisplay = typeof state === 'string' ? state : state?.state_name || state?.name || state?.display || stateValue;
                    const stateKey = typeof state === 'string' ? `state-${index}` : state?._id || state?.id || state?.state_id || `state-${index}`;
                    return <option key={stateKey} value={stateValue}>{stateDisplay}</option>;
                  })}
                </select>
                {errors.state && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.state}</span>}
              </div>

              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.city ? "#d32f2f" : COLORS.text }}>
                  City
                </label>
                <select
                  className="form-select form-select-sm"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.city ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={selectedCity}
                  onBlur={(e) => validateField("city", e.target.value)}
                  onChange={handleCityDropdown}
                  disabled={!selectedState}
                >
                  <option value="" disabled>Select City</option>
                  {Array.isArray(cities) && cities.map((city, index) => {
                    const cityValue = typeof city === 'string' ? city : city?.city_name || city?.name || city?.value || '';
                    const cityDisplay = typeof city === 'string' ? city : city?.city_name || city?.name || city?.display || cityValue;
                    const cityKey = typeof city === 'string' ? `city-${index}` : city?._id || city?.id || city?.city_id || `city-${index}`;
                    return <option key={cityKey} value={cityValue}>{cityDisplay}</option>;
                  })}
                </select>
                {errors.city && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.city}</span>}
              </div>

              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
                  Department
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  style={{ background: "#f3f4f6", color: "#6b7280", border: "1px solid #d1d5db", cursor: "not-allowed" }}
                  value={formValues.department}
                  readOnly
                />
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4 mb-3">
                <label style={{ fontFamily: "Poppins", fontSize: "12px", color: errors.role ? "#d32f2f" : COLORS.text }}>
                  Role
                </label>
                <select
                  className="form-select form-select-sm"
                  style={{
                    background: "#ffffff",
                    color: "#111827",
                    border: errors.role ? "1px solid #d32f2f" : "1px solid #d1d5db",
                  }}
                  value={selectedRole}
                  onBlur={(e) => validateField("role", e.target.value)}
                  onChange={handleDropdownChange1}
                >
                  <option value="" disabled>Select Role</option>
                  {Object.keys(roleNames).map((Role_name) => (
                    <option key={Role_name} value={Role_name}>{roleNames[Role_name]}</option>
                  ))}
                </select>
                {errors.role && <span style={{ color: "#d32f2f", fontSize: "11px", fontWeight: 500 }}>{errors.role}</span>}
              </div>

              {isEditMode && (
                <div className="col-sm-4 mb-3">
                  <label style={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text }}>
                    Activation Status
                  </label>
                  <select
                    className="form-select form-select-sm"
                    style={{ background: "#ffffff", color: "#111827", border: "1px solid #d1d5db" }}
                    value={activation.toString()}
                    onChange={(e) => setActivation(e.target.value === 'true')}
                  >
                    <option value="false">Inactive</option>
                    <option value="true">Active</option>
                  </select>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer d-flex flex-row justify-content-right border-0 mt-3" style={{ flexShrink: 0 }}>
            <button
              type="button"
              className="btn btn-sm rounded-2 fw-medium"
              onClick={clearForm}
              style={{
                color: COLORS.button,
                width: "120px",
                border: "1px solid #033538",
              }}
            >
              Clear
            </button>
            <button
              type="submit"
              className="btn btn-sm rounded-2 fw-medium"
              style={{
                background: COLORS.button,
                color: COLORS.background,
                width: "120px",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <div className="spinner-border spinner-border-sm text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                isEditMode ? "Update" : "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewUser;